module.exports = __webpack_public_path__ + "img/ic_qmarker_dumpster_cluster.e9c1dadb.png";